var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "contents" } },
    [
      _c("div", { staticClass: "company-area no-top" }, [
        _vm.photoClip.companyName
          ? _c(
              "h1",
              {
                staticClass: "company-title",
                attrs: { "data-test": "company-name" },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.photoClip.companyName) + "\n    "
                ),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contents-inner" }, [
        _c(
          "dl",
          {
            staticClass: "photoclip-block",
            style:
              "background: url(" +
              _vm.userCommonImageUrlForSp +
              "/bg_stripe_gray.png) repeat top left;",
            attrs: { "data-test": "photo-clip-block" },
          },
          [
            _vm._l(_vm.photoClip.photoInfoList, function (photoInfo, i) {
              return [
                _c("dt", { key: "img-" + i }, [
                  photoInfo.image
                    ? _c("img", {
                        staticClass: "max-w100 image-height-auto",
                        attrs: {
                          src: _vm.getPhotoUrl(photoInfo.image),
                          "data-test": "photo-" + i,
                        },
                      })
                    : _vm._e(),
                ]),
                _vm._v(" "),
                photoInfo.caption
                  ? _c("dd", {
                      key: "caption-" + i,
                      staticClass: "pega-pre-wrap pega-break",
                      attrs: { "data-test": "caption-" + i },
                      domProps: { textContent: _vm._s(photoInfo.caption) },
                    })
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("user-preview-menu-sp", {
        attrs: { titles: ["募集情報", "インタビュー"] },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }